module.exports = __webpack_public_path__ + "static/media/0223_IMG_CCF.0b712953.webp";